<template>
  <div class="py-4">
    <div v-if="showPrint" id="section-to-print">
      <VoucherPoint :voucher="dataPrint.voucher"
      :meta="dataPrint.meta" :showqr="1"/>
    </div>
    <div class="container-fluid">
      <form @submit.prevent="searchFilters()" class="card shadow-sm mb-4">
        <div class="card-body">
          <div class="row">
            <b-form-group
              label="Fecha Inicio"
              label-for="input-date-from"
              class="col-12 col-sm-6 col-lg-2">
              <DatePicker
                id="input-date-from"
                v-model="dateFrom"
                :config="optionsFrom"
                placeholder="dd/mm/aaaa"
                @dp-change="onStartChange"
                required
              ></DatePicker>
            </b-form-group>
            <b-form-group
              label="Fecha Fin"
              label-for="input-date-to"
              class="col-12 col-sm-6 col-lg-2">
              <DatePicker
                id="input-date-to"
                v-model="dateTo"
                :config="optionsTo"
                placeholder="dd/mm/aaaa"
                required
              ></DatePicker>
            </b-form-group>
            <b-form-group
              label="Documento / Boleta"
              label-for="input-search"
              class="col-12 col-sm-6 col-lg-3">
              <b-form-input
                id="input-search"
                v-model="search"
                placeholder="N° Documento / N° Boleta"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              label="Vendedor"
              label-for="input-seller"
              class="col-12 col-sm-6 col-lg-3"
              v-if="listUser.length > 0">
              <select class="form-control" v-model="sellerId">
                <option value="">Todos</option>
                <option :value="elem.id" v-for="elem in listUser" :key="elem.id">
                  {{elem.name}}
                </option>
              </select>
            </b-form-group>
            <div class="col-12 col-lg-2">
              <label>&nbsp;</label>
              <button type="submit" class="btn btn-primary btn-block">
                Buscar
              </button>
            </div>
          </div>
        </div>
      </form>
      <Loader v-show="loading"></Loader>
      <div v-show="!loading" class="row">
        <div class="col-12">
          <b-card>
            <div class="col-12 table-responsive" >
              <table id="table1" class="table" style="background: white;">
                <thead>
                  <tr>
                    <th class="align-middle" scope="col" style="min-width:180px">Fecha</th>
                    <th class="align-middle" scope="col" style="min-width:180px">N° Boleta</th>
                    <th class="align-middle" scope="col" style="min-width:200px">Vendedor</th>
                    <th class="align-middle" scope="col">Documento</th>
                    <th class="align-middle" scope="col">Método Pago</th>
                    <th class="align-middle" scope="col">Total</th>
                    <th class="align-middle" scope="col">Estado</th>
                    <th class="align-middle" scope="col" style="min-width:130px">Acciones</th>
                  </tr>
                </thead>
                <tbody v-if="itemsTransaction.length > 0">
                  <tr v-for="item in itemsTransaction" :key="item.transaction">
                    <td>{{item.paymentDate}}</td>
                    <td>{{item.idInvoice}}</td>
                    <td>{{item.seller}}</td>
                    <td>{{item.document}}</td>
                    <td>{{item.paymentMethod}}</td>
                    <td class="text-right">{{item.total}}</td>
                    <td>
                      <b-badge v-if="item.state === 'Anulado'" variant="danger">
                        {{item.state}}
                      </b-badge>
                      <b-badge v-else variant="primary">{{item.state}}</b-badge>
                    </td>
                    <td>
                      <a
                        href="#"
                        @click.prevent="print(item, item.isAnuled)"
                        title="Ver boleta">
                        <i class="material-icons mr-2 text-secondary">visibility</i>
                      </a>
                      <a
                        href="#"
                        @click.prevent="onCancel(item)"
                        title="Anular transacción"
                        v-if="item.state !== 'Anulado'">
                        <i class="material-icons text-danger">delete</i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-if="!itemsTransaction.length" class="text-center py-4">
                <h3>No se encontraron registros</h3>
              </div>
            </div>
            <div class="overflow-auto mt-3" v-if="pageTransaction.lastPage > 1">
              <b-pagination
                v-model="pageTransaction.currentPage"
                :total-rows="pageTransaction.total"
                :per-page="pageTransaction.perPage"
                aria-controls="table1"
                align="center"
                @change="pageChange"
              ></b-pagination>
            </div>
          </b-card>
        </div>
      </div>
    </div>

    <!-- modal confirm cancel -->
    <b-modal
      v-model="modalConfirm"
      hide-header
      cancel-title="Cerrar"
      ok-title="Anular"
      ok-variant="action btn-lg ml-3"
      @ok="handleOk"
    >
      <div class="text-center p-4">
        <p class="lead">
          ¿Estás segur@ que deseas anular esta transacción?
        </p>

        <form ref="form" @submit.stop.prevent="cancelTrans">
          <b-form-group
            class="text-left"
            :state="typeCancelState"
            label="Tipo de anulación"
            label-for="typeCancel"
            invalid-feedback="Tipo de anulación es requerido">
            <b-form-select
              id="typeCancel"
              :state="typeCancelState"
              v-model="typeCancel"
              :options="{ '2': 'Anula usuario', '3': 'Anula estafa',
                '4': 'Anula devolución', '5': 'Posible fraude' }"
              required
            >
            </b-form-select>
          </b-form-group>
          <b-form-group
            :state="typeCancelState"
            label=""
            label-for="textarea-state"
            invalid-feedback="Motivo de la anulación es requerido">
            <b-form-textarea
              id="textarea-state"
              v-model="infoCancel"
              :state="infoCancelState"
              placeholder="Escribe aquí el motivo de la anulación"
              rows="3"
              required
            ></b-form-textarea>
          </b-form-group>
        </form>
      </div>
    </b-modal>

  </div>
</template>

<script>
import moment from 'moment';
import DatePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import api from '../api';

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      loading: false,
      list: [],
      modalConfirm: false,
      modalView: false,
      dateFrom: new Date(),
      dateTo: new Date(),
      optionsFrom: {
        format: 'YYYY/MM/DD',
        locale: 'es-us',
        useCurrent: false,
        maxDate: moment(),
        icons: {
          time: 'fa fa-clock',
          date: 'fa fa-calendar',
          up: 'fa fa-arrow-up',
          down: 'fa fa-arrow-down',
          previous: 'fa fa-chevron-left',
          next: 'fa fa-chevron-right',
          today: 'fa fa-calendar-check',
          clear: 'fa fa-trash-alt',
          close: 'fa fa-times-circle',
        },
      },
      optionsTo: {
        format: 'YYYY/MM/DD',
        locale: 'es-us',
        useCurrent: false,
        maxDate: moment(),
        icons: {
          time: 'fa fa-clock',
          date: 'fa fa-calendar',
          up: 'fa fa-arrow-up',
          down: 'fa fa-arrow-down',
          previous: 'fa fa-chevron-left',
          next: 'fa fa-chevron-right',
          today: 'fa fa-calendar-check',
          clear: 'fa fa-trash-alt',
          close: 'fa fa-times-circle',
        },
      },
      search: '',
      itemsTransaction: [],
      listUser: [],
      sellerId: '',
      infoCancel: '',
      typeCancel: '',
      current: '',
      pageTransaction: {
        perPage: 10,
        currentPage: 1,
        lastPage: 1,
        total: 0,
      },
      roleId: null,
      dataPrint: {},
      showPrint: false,
      typeCancelState: null,
      infoCancelState: null,
    };
  },
  created() {
    this.getItems();
    this.getListUsers();
  },
  methods: {
    async getItems() {
      const { eventId } = this.$route.params;
      this.loading = true;
      const payload = {
        limit: this.pageTransaction.perPage,
        page: this.pageTransaction.currentPage,
        activityId: eventId,
        startDate: this.formatDate(this.dateFrom),
        endDate: this.formatDate(this.dateTo),
        search: this.search,
        sellerId: this.sellerId,
        anuled: 1,
      };
      /* eslint-disable camelcase */
      const {
        data,
        last_page,
        current_page,
        total,
      } = await api.getReportTransactionPoints(payload);
      this.itemsTransaction = data;
      this.pageTransaction.currentPage = current_page;
      this.pageTransaction.lastPage = last_page;
      this.pageTransaction.total = total;
      this.loading = false;
      /* eslint-disable camelcase */
    },
    async getListUsers() {
      const { eventId } = this.$route.params;
      const data = await api.getListUsers(eventId);
      this.listUser = data.childrens;
      this.roleId = data.roleId;
    },
    searchFilters() {
      this.getItems();
    },
    pageChange(page) {
      this.pageTransaction.currentPage = page;
      this.getItems();
    },
    pageChangePaymentMethods(page) {
      this.pagePaymentMethods.currentPage = page;
      this.getItems();
    },
    onCancel(item) {
      this.current = item;
      this.modalConfirm = true;
      this.typeCancel = '';
      this.infoCancel = '';
      this.typeCancelState = null;
      this.infoCancelState = null;
    },
    onShowDetail(item) {
      this.current = item;
      this.current.detailsParse = JSON.parse(item.details);
      this.modalDetails = true;
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.typeCancelState = this.typeCancel ? 'valid' : 'invalid';
      this.infoCancelState = this.infoCancel ? 'valid' : 'invalid';
      return valid;
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.cancelTrans();
    },
    async cancelTrans() {
      try {
        this.$store.dispatch('changeLoadingJoinnus', true);
        if (!this.checkFormValidity()) {
          return;
        }
        this.modalConfirm = false;
        const { eventId } = this.$route.params;
        const payload = {
          transaction: {
            code: this.current.code,
          },
          eventId,
          annulment: {
            info: this.infoCancel,
            type: this.typeCancel,
          },
        };
        const resp = await api.cancelTransaction(payload);
        if (resp.success) {
          if (resp.voucher) {
            const { voucher } = resp;
            const currency = 'S/.';
            let method = '';
            let methodCard = '';

            if (voucher.methods.efectivo && voucher.methods.pos) {
              method = 'multiple';
              methodCard = voucher.methods.pos.cardType;
              voucher.methods.efectivo.amountReturned = voucher.methods.efectivo.amountReturned
                ? voucher.methods.efectivo.amountReturned : 0;
            } else {
              if (voucher.methods.efectivo && voucher.methods.efectivo.paymentMethod) {
                method = voucher.methods.efectivo.paymentMethod;
                voucher.methods.efectivo.amountReturned = voucher.methods.efectivo.amountReturned
                  ? voucher.methods.efectivo.amountReturned : 0;
              }
              if (voucher.methods.pos && voucher.methods.pos.paymentMethod) {
                method = voucher.methods.pos.paymentMethod;
                methodCard = voucher.methods.pos.cardType;
              }
              if (voucher.methods.qrvisa && voucher.methods.qrvisa.paymentMethod) {
                method = voucher.methods.qrvisa.paymentMethod;
              }
            }

            const result = Object.keys(voucher.items).map(x => (
              parseFloat(voucher.items[x].total, 2))).reduce((a, b) => (a + b));
            voucher.totalAmount = result.toFixed(2);

            const meta = {
              currency,
              method,
              methodCard,
              siteUrl: 'https://www.joinnus.com',
            };

            this.dataPrint = {};
            this.dataPrint.meta = { ...meta };
            this.dataPrint.voucher = { ...voucher };
            this.showPrint = true;
            setTimeout(() => {
              window.print();
            }, 1000);
          }

          this.getItems();
        }
      } catch (error) {
        console.error("error =>> ", error);
      } finally {
        this.$store.dispatch('changeLoadingJoinnus', false);
      }      
    },
    async print(item, isAnuled) {
      try {
        const payload = {
          transactionCode: item.code,
        };
        let data = {};
        
        this.$store.dispatch('changeLoadingJoinnus', true);
        
        if (!isAnuled) {
          data = await api.getElectronicBilling(payload);
        } else {
          data = await api.getCreditNote(payload);
        }

        if (!data || !data.methods) {
          return;
        }

        const currency = 'S/.';
        let method = '';
        let methodCard = '';
        if (data.methods.efectivo && data.methods.pos) {
          method = 'multiple';
          methodCard = data.methods.pos.cardType;
          data.methods.efectivo.amountReturned = data.methods.efectivo.amountReturned
            ? data.methods.efectivo.amountReturned : 0;
        } else {
          if (data.methods.efectivo && data.methods.efectivo.paymentMethod) {
            method = data.methods.efectivo.paymentMethod;
            data.methods.efectivo.amountReturned = data.methods.efectivo.amountReturned
              ? data.methods.efectivo.amountReturned : 0;
          }
          if (data.methods.pos && data.methods.pos.paymentMethod) {
            method = data.methods.pos.paymentMethod;
            methodCard = data.methods.pos.cardType;
          }
          if (data.methods.qrvisa && data.methods.qrvisa.paymentMethod) {
            method = data.methods.qrvisa.paymentMethod;
          }
        }

        const result = Object.keys(data.items).map(x => (
          parseFloat(data.items[x].total, 2))).reduce((a, b) => (a + b));
        data.totalAmount = result.toFixed(2);

        const meta = {
          currency,
          method,
          methodCard,
          siteUrl: 'https://www.joinnus.com',
        };

        this.dataPrint = {};
        this.dataPrint.meta = { ...meta };
        this.dataPrint.voucher = { ...data };
        this.showPrint = true;
        setTimeout(() => {
          window.print();
        }, 500);
      } catch (error) {
        console.log("error =>>>", error);
      } finally{
        this.$store.dispatch('changeLoadingJoinnus', false);
      }
    },
    onStartChange(e) {
      this.$set(this.optionsTo, 'minDate', e.date || null);
      document.getElementById('input-date-to').focus();
    },
  },
};
</script>
<style>
  .table th{
    border-top: 0 !important;
  }
</style>
